<div class="sidebar-detail">
  <div class="sidebar-panel">
    <div class="sidebar-content">
      <div class="panel-title">
        {{ isAdjustTransaction ? 'Transaction Adjustment Details' : 'Transaction Details' }}
        <button class="close-icon" (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      @if (isExchange) {
        <div class="detail-row">
          <div class="field-label">Transaction ID</div>
          <div class="field-value copyable-value">
            <span class="olv-hash" [matTooltip]="transaction.id" matTooltipPosition="above">{{
              shortenAddress(transaction.id)
            }}</span>
            <span [matTooltip]="idTooltipText" matTooltipPosition="above" #idTooltip="matTooltip">
              <img
                src="shared-assets/icons/copy.svg"
                class="copy-icon"
                (click)="copyToClipboard(transaction.id, idTooltip, 'id')"
                alt="Copy icon"
              />
            </span>
          </div>
        </div>
        <div class="detail-row">
          <div class="field-label">{{ accountFieldLabel }}</div>
          <div class="field-value">{{ merchantDisplayName }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Type</div>
          <div class="field-value">{{ transaction.direction }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Asset</div>
          <div class="field-value">{{ transaction.cryptocurrency }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Amount</div>
          <div class="field-value">
            {{ formatWithPrecision(transaction.amount, transaction.amountDisplayPrecision) }}
          </div>
        </div>
        <div class="detail-row">
          <div class="field-label">USD Amount</div>
          <div class="field-value">
            {{
              formatBaseWithPrecision(
                transaction.amountBaseCurrency,
                transaction.baseCurrencyDisplayPrecision,
                transaction.baseCurrencySymbol
              )
            }}
          </div>
        </div>
        <div class="detail-row">
          <div class="field-label">Rate</div>
          <div class="field-value">{{ rateDisplay }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Fee</div>
          <div class="field-value">{{ formatAmount(transaction.totalFees, true) }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Date</div>
          <div class="field-value">{{ formatDateStandard(transaction.date).slice(0, 10) }}</div>
        </div>
      }
      @if (!isExchange) {
        <div class="detail-row">
          <div class="field-label">Transaction ID</div>
          <div class="field-value copyable-value">
            <span class="olv-hash" [matTooltip]="transaction.id" matTooltipPosition="above">{{
              shortenAddress(transaction.id)
            }}</span>
            <span [matTooltip]="idTooltipText" matTooltipPosition="above" #idTooltip="matTooltip">
              <img
                src="shared-assets/icons/copy.svg"
                class="copy-icon"
                (click)="copyToClipboard(transaction.id, idTooltip, 'id')"
                alt="Copy icon"
              />
            </span>
          </div>
        </div>
        <div class="detail-row">
          <div class="field-label">{{ accountFieldLabel }}</div>
          <div class="field-value">{{ merchantDisplayName }}</div>
        </div>
        <div class="detail-row">
          <div class="field-label">Currency</div>
          <div class="field-value">{{ transaction.cryptocurrency }}</div>
        </div>
        @if (!isAdjustTransaction) {
          <div class="detail-row">
            <div class="field-label">Amount</div>
            <div class="field-value">
              {{ formatWithPrecision(transaction.amount, transaction.amountDisplayPrecision) }}
            </div>
          </div>
        }
        <div class="detail-row">
          <div class="field-label">Amount ({{ transaction.baseCurrencySymbol }})</div>
          <div class="field-value">
            {{
              formatBaseWithPrecision(
                transaction.amountBaseCurrency,
                transaction.baseCurrencyDisplayPrecision,
                transaction.baseCurrencySymbol
              ) || 'N/A'
            }}
          </div>
        </div>
        @if (showRateRow) {
          <div class="detail-row">
            <div class="field-label">Rate</div>
            <div class="field-value">
              {{ rateDisplay }}
              @if (isSettlementApp && transaction.requiresExchangeRateOverride) {
                <span
                  class="pending-rate-indicator"
                  role="img"
                  [attr.aria-label]="pendingRateTooltip"
                  [matTooltip]="pendingRateTooltip"
                  matTooltipPosition="above"
                >
                  <mat-icon aria-hidden="true">sync_problem</mat-icon>
                </span>
              } @else if (isSettlementApp && transaction.isExchangeRateOverridden) {
                <span
                  class="manual-rate-indicator"
                  role="img"
                  [attr.aria-label]="manualRateTooltip"
                  [matTooltip]="manualRateTooltip"
                  matTooltipPosition="above"
                >
                  <mat-icon aria-hidden="true">sync_problem</mat-icon>
                </span>
              }
            </div>
          </div>
        }
        @if (!isAdjustTransaction) {
          <div class="detail-row">
            <div class="field-label">Total Fees ($)</div>
            <div class="field-value">{{ formatAmount(transaction.totalFees, true) }}</div>
          </div>
        }
        <div class="detail-row">
          <div class="field-label">Date</div>
          <div class="field-value">{{ formatDateStandard(transaction.date) }}</div>
        </div>

        @if (transaction.settlementDate) {
          <div class="detail-row">
            <div class="field-label">Settlement Date</div>
            <div class="field-value">{{ formatDateStandard(transaction.settlementDate) }}</div>
          </div>
        }
        @if (transaction.direction !== 'Deposit') {
          <div class="detail-row">
            <div class="field-label">Prepared by</div>
            <div class="field-value">{{ transaction.preparedBy }}</div>
          </div>
        }
        @if (transaction.direction === 'Deposit') {
          <div class="detail-row">
            <div class="field-label">Approved by</div>
            <div class="field-value">{{ transaction.approvedBy }}</div>
          </div>
        }
        @if (transaction.resolvedBy || transaction.resolvedByDisplayName) {
          <div class="detail-row">
            <div class="field-label">Resolved by</div>
            <div class="field-value">{{ transaction.resolvedBy || transaction.resolvedByDisplayName }}</div>
          </div>
        }
        @if (transaction.resolvedAt) {
          <div class="detail-row">
            <div class="field-label">Resolved At</div>
            <div class="field-value">{{ formatDateStandard(transaction.resolvedAt) || 'N/A' }}</div>
          </div>
        }
        @if (transaction.resolution) {
          <div class="detail-row">
            <div class="field-label">Resolution</div>
            <div class="field-value">{{ resolutionToString(transaction.resolution) }}</div>
          </div>
        }
        <div class="detail-row">
          <div class="field-label">Type</div>
          <div class="field-value">{{ transaction.direction || 'Payout' }}</div>
        </div>
        @if (!isAdjustTransaction && isSettlementApp) {
          <div class="detail-row">
            <div class="field-label">Risk Level</div>
            <div class="field-value">
              <app-state-badge type="risk" [value]="transaction.riskLevel"></app-state-badge>
              @if (needsRiskBeforeApproval) {
                <span
                  class="risk-assessment-indicator"
                  role="img"
                  [attr.aria-label]="riskAssessmentIndicatorTooltip"
                  [matTooltip]="riskAssessmentIndicatorTooltip"
                  matTooltipPosition="above"
                >
                  <mat-icon aria-hidden="true">warning</mat-icon>
                </span>
              }
            </div>
          </div>
          @if (transaction.riskCategoryName) {
            <div class="detail-row">
              <div class="field-label">Risk Exposure</div>
              <div class="field-value">
                {{ transaction.riskCategoryName }}
                @if (transaction.riskExposureName != null) {
                  <span class="risk-exposure-category-id">({{ transaction.riskExposureName }})</span>
                }
              </div>
            </div>
          }
        }
        <div class="detail-row">
          <div class="field-label">Status</div>
          <div class="field-value">
            <app-state-badge [status]="transaction.status"></app-state-badge>
          </div>
        </div>
        @if (linkedExchangeRateTransactions.length) {
          <div class="detail-row related-transactions">
            <div class="field-label">Related transactions</div>
            <div class="related-table-wrap">
              <table class="related-table">
                <thead>
                  <tr>
                    <th>Transaction ID</th>
                    <th>Type</th>
                  </tr>
                </thead>
                <tbody>
                  @for (linked of linkedExchangeRateTransactions; track linked.transactionId) {
                    <tr>
                      <td>
                        <div class="field-value copyable-value">
                          <span class="olv-hash" [matTooltip]="linked.transactionId" matTooltipPosition="above">
                            {{ shortenAddress(linked.transactionId) }}
                          </span>
                          <button
                            type="button"
                            class="copy-icon-button"
                            [matTooltip]="idTooltipText"
                            matTooltipPosition="above"
                            #linkedTooltip="matTooltip"
                            aria-label="Copy transaction ID"
                            (click)="copyToClipboard(linked.transactionId, linkedTooltip, 'id')"
                          >
                            <img src="shared-assets/icons/copy.svg" class="copy-icon" alt="" />
                          </button>
                        </div>
                      </td>
                      <td>{{ linked.transactionType }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (transaction.direction !== 'Credit Adjustment' && transaction.direction !== 'Debit Adjustment') {
          <div class="detail-row">
            <div class="field-label">Sending Wallet Name</div>
            <div class="field-value">{{ transaction.sendingWalletName || 'N/A' }}</div>
          </div>

          <div class="detail-row">
            <div class="field-label">Sending Wallet</div>
            <div class="field-value copyable-value olv-address">
              {{ shortenAddress(transaction.sendingWallet) }}
              <span [matTooltip]="sendingTooltipText" matTooltipPosition="above" #sendingTooltip="matTooltip">
                <img
                  src="shared-assets/icons/copy.svg"
                  class="copy-icon"
                  (click)="copyToClipboard(transaction.sendingWallet, sendingTooltip, 'sending')"
                  alt="Copy icon"
                />
              </span>
            </div>
          </div>

          <div class="detail-row">
            <div class="field-label">Receiving Wallet Name</div>
            <div class="field-value">{{ transaction.receivingWalletName || 'N/A' }}</div>
          </div>

          <div class="detail-row">
            <div class="field-label">Receiving Wallet</div>
            <div class="field-value copyable-value olv-address">
              {{ shortenAddress(transaction.receivingWallet) }}
              <span [matTooltip]="receivingTooltipText" matTooltipPosition="above" #receivingTooltip="matTooltip">
                <img
                  src="shared-assets/icons/copy.svg"
                  class="copy-icon"
                  (click)="copyToClipboard(transaction.receivingWallet, receivingTooltip, 'receiving')"
                  alt="Copy icon"
                />
              </span>
            </div>
          </div>
        }
        @if (!isAdjustTransaction) {
          <div class="detail-row">
            <div class="field-label">Transaction Hash</div>
            <div class="field-value copyable-value">
              @if (transaction.transactionHash) {
                @if (getTransactionExplorerUrl(); as explorerUrl) {
                  <a
                    [href]="explorerUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="link olv-hash"
                    matTooltip="Go to blockchain"
                    matTooltipPosition="above"
                  >
                    {{ shortenAddress(transaction.transactionHash) }}
                  </a>
                } @else {
                  {{ shortenAddress(transaction.transactionHash) }}
                }

                <span [matTooltip]="hashTooltipText" matTooltipPosition="above" #hashTooltip="matTooltip">
                  <img
                    src="shared-assets/icons/copy.svg"
                    class="copy-icon"
                    (click)="copyToClipboard(transaction.transactionHash, hashTooltip, 'hash')"
                    alt="Copy icon"
                  />
                </span>
              } @else {
                <span class="na-text">N/A</span>
              }
            </div>
          </div>
        }
        @if (transaction.tronNetworkInfo && !isAdjustTransaction) {
          <div class="network-info">
            @if (transaction.tronNetworkInfo.trxBurned !== undefined) {
              <div class="detail-row">
                <div class="field-label">TRX Burned</div>
                <div class="field-value">
                  {{
                    formatWithPrecision(
                      transaction.tronNetworkInfo.trxBurned,
                      transaction.tronNetworkInfo.trxBurnedDisplayPrecision
                    )
                  }}
                </div>
              </div>
            }
            @if (transaction.tronNetworkInfo.trxBurnedBaseCurrency !== undefined) {
              <div class="detail-row">
                <div class="field-label">TRX Burned ({{ transaction.baseCurrencySymbol }})</div>
                <div class="field-value">
                  {{
                    formatBaseWithPrecision(
                      transaction.tronNetworkInfo.trxBurnedBaseCurrency,
                      transaction.tronNetworkInfo.trxBurnedBaseCurrencyDisplayPrecision,
                      transaction.baseCurrencySymbol
                    )
                  }}
                </div>
              </div>
            }
            @if (transaction.tronNetworkInfo.energyUsed !== undefined) {
              <div class="detail-row">
                <div class="field-label">Energy Used</div>
                <div class="field-value">{{ transaction.tronNetworkInfo.energyUsed }}</div>
              </div>
            }
            @if (transaction.tronNetworkInfo.bandwidthUsed !== undefined) {
              <div class="detail-row">
                <div class="field-label">Bandwidth Used</div>
                <div class="field-value">{{ transaction.tronNetworkInfo.bandwidthUsed }}</div>
              </div>
            }
          </div>
        }
        @if (transaction.ethereumNetworkInfo && !isAdjustTransaction) {
          <div class="network-info">
            @if (transaction.ethereumNetworkInfo.gasFeeUsedEth !== undefined) {
              <div class="detail-row">
                <div class="field-label">{{ gasFeeLabel }}</div>
                <div class="field-value">
                  {{
                    formatWithPrecision(
                      transaction.ethereumNetworkInfo.gasFeeUsedEth,
                      transaction.ethereumNetworkInfo.gasFeeUsedEthDisplayPrecision
                    )
                  }}
                </div>
              </div>
            }
            @if (transaction.ethereumNetworkInfo.gasFeeUsedBaseCurrency !== undefined) {
              <div class="detail-row">
                <div class="field-label">Gas Fee ({{ transaction.baseCurrencySymbol }})</div>
                <div class="field-value">
                  {{
                    formatBaseWithPrecision(
                      transaction.ethereumNetworkInfo.gasFeeUsedBaseCurrency,
                      transaction.ethereumNetworkInfo.gasFeeUsedBaseCurrencyDisplayPrecision,
                      transaction.baseCurrencySymbol
                    )
                  }}
                </div>
              </div>
            }
          </div>
        }
        @if (isAdjustTransaction) {
          <div class="detail-row">
            <div class="field-label">Reason</div>
            <div class="field-value">{{ transaction.reason }}</div>
          </div>

          @if (transaction.isRetried) {
            <div class="detail-row">
              <div class="field-label">Retried</div>
              <div class="field-value">This transaction was retried</div>
            </div>
          }
        }
        @if (transaction.showExternalComments) {
          <div class="comments-heading">External Comments</div>
          <textarea
            class="comment-box"
            aria-label="External Comments"
            placeholder="Enter your comment"
            [(ngModel)]="externalCommentText"
            [disabled]="true"
          ></textarea>
        }
        @if (!showApproveReject && !showAcknowledge) {
          <ng-container *ngTemplateOutlet="commentsBlock"></ng-container>
        }
        @if (rejectErrorMessage) {
          <div class="error-message" role="alert">
            <mat-icon class="error-icon">error</mat-icon>
            {{ rejectErrorMessage }}
          </div>
        }
        @if (errorMessage) {
          <div class="error-message" role="alert">
            <mat-icon class="error-icon">error</mat-icon>
            {{ errorMessage }}
          </div>
        }
      }
    </div>

    @if (transaction.warningDetails) {
      <div
        class="warning-label-banner"
        [class.expanded]="warningLabelExpanded"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="warningLabelExpanded"
        (click)="warningLabelExpanded = !warningLabelExpanded"
        (keydown.enter)="warningLabelExpanded = !warningLabelExpanded"
        (keydown.space)="$event.preventDefault(); warningLabelExpanded = !warningLabelExpanded"
      >
        <div class="warning-label-header">
          <span class="warning-label-icon"><mat-icon>info</mat-icon></span>
          <span class="warning-label-title">{{ transaction.warningDetails.title }}</span>
          <mat-icon class="warning-label-chevron">{{ warningLabelExpanded ? 'expand_more' : 'expand_less' }}</mat-icon>
        </div>
        @if (warningLabelExpanded) {
          <div class="warning-label-text">{{ transaction.warningDetails.description }}</div>
        }
      </div>
    }

    @if (hasSidebarActions) {
      <div class="sidebar-actions">
        @if (showAcknowledge) {
          <ng-container *ngTemplateOutlet="commentsBlock"></ng-container>

          <app-button
            buttonVariant="primary"
            buttonType="button"
            [state]="processingButtonState"
            *appHasPermission="{ resource: Resources.Tasks, scope: Scopes.Acknowledge }"
            (buttonClick)="acknowledgeTask()"
            testId="acknowledge-button"
            ariaLabel="Acknowledge Transaction"
          >
            {{ isProcessing ? 'Processing...' : 'Acknowledge' }}
          </app-button>
        }
        @if (showApproveReject) {
          <ng-container *ngTemplateOutlet="commentsBlock"></ng-container>

          @if (needsRiskBeforeApproval) {
            <app-button
              buttonVariant="primary"
              buttonType="button"
              [state]="processingButtonState"
              *appHasPermission="{ resource: transactionResource, scope: setRiskScope }"
              (buttonClick)="openRiskSelectionDialog()"
              testId="set-risk-button"
              ariaLabel="Set Risk Level"
            >
              {{ isProcessing ? 'Processing...' : 'Set Risk' }}
            </app-button>
          } @else {
            <app-button
              buttonVariant="primary"
              buttonType="button"
              [state]="approveButtonState"
              *appHasPermission="{ resource: transactionResource, scope: approveScope }"
              (buttonClick)="openOtp('approve')"
              testId="approve-button"
              ariaLabel="Approve Transaction"
            >
              {{ isProcessing ? 'Processing...' : 'Approve' }}
            </app-button>
          }
          <app-button
            buttonVariant="danger"
            buttonType="button"
            [state]="processingButtonState"
            *appHasPermission="{ resource: transactionResource, scope: rejectScope }"
            (buttonClick)="rejectTransaction()"
            testId="reject-button"
            ariaLabel="Reject Transaction"
          >
            Reject
          </app-button>
        }
        @if (showAllowsAdjustment) {
          <app-button
            buttonVariant="secondary"
            buttonType="button"
            [state]="processingButtonState"
            *appHasPermission="{ resource: transactionResource, scope: Scopes.CreateAdjustment }"
            (buttonClick)="openAdjustDialog()"
            testId="adjust-button"
            ariaLabel="Adjust Transaction"
          >
            Adjust Transaction
          </app-button>
        }
        @if (showSpeedupButton) {
          <app-button
            buttonVariant="primary"
            buttonType="button"
            [state]="processingButtonState"
            *appHasPermission="{ resource: transactionResource, scope: Scopes.Speedup }"
            (buttonClick)="openOtp('speedup')"
            testId="speedup-button"
            ariaLabel="Speedup Transaction"
          >
            Speedup
          </app-button>
        }
        @if (showCancelButton) {
          <app-button
            buttonVariant="danger"
            buttonType="button"
            [state]="processingButtonState"
            *appHasPermission="{ resource: transactionResource, scope: Scopes.Cancel }"
            (buttonClick)="openOtp('cancel')"
            testId="cancel-button"
            ariaLabel="Cancel Transaction"
          >
            Cancel
          </app-button>
        }
        @if (canCancelPrepared) {
          <app-button
            buttonVariant="danger"
            buttonType="button"
            [state]="processingButtonState"
            *appHasPermission="{ resource: transactionResource, scope: Scopes.CancelPrepared }"
            (buttonClick)="CancelPrepared()"
            testId="cancel-prepared-button"
            ariaLabel="Cancel Prepared Transaction"
          >
            Cancel
          </app-button>
        }
        @if (showRetry) {
          <!-- TODO: Add retry permission *appHasPermission="{ resource: transactionResource, scope: Scopes.Retry }" -->
          <app-button
            buttonVariant="secondary"
            buttonType="button"
            [state]="processingButtonState"
            (buttonClick)="openOtp('retry')"
            testId="retry-button"
            ariaLabel="Retry Transaction"
          >
            Retry Transaction
          </app-button>
        }
        @if (canReverse) {
          <div *appHasPermission="{ resource: transactionResource, scope: Scopes.ReverseDeposit }">
            <app-button
              buttonVariant="danger"
              buttonType="button"
              [state]="processingButtonState"
              (buttonClick)="openReverseDialog()"
              testId="reverse-button"
              ariaLabel="Create Reversal"
            >
              Create Reversal
            </app-button>
          </div>
        }
        @if (showExchangeRateInput) {
          <div
            class="exchange-rate-block"
            *appHasPermission="{ resource: setExchangeRateResource, scope: Scopes.SetExchangeRate }"
          >
            <div class="comments-heading">Exchange rate</div>
            @if (exchangeRateHint; as hint) {
              <span class="rate-hint">{{ hint }}</span>
            }
            <input
              class="rate-input"
              type="number"
              min="0"
              [step]="exchangeRateStep"
              aria-label="Exchange rate"
              [class.invalid]="exchangeRateError"
              [attr.aria-invalid]="!!exchangeRateError"
              [(ngModel)]="exchangeRate"
              (input)="enforceRatePrecision($event)"
              placeholder="Enter the exchange rate"
            />
            @if (exchangeRateError; as error) {
              <span class="rate-error" role="alert">{{ error }}</span>
            }
            <span class="rate-hint"
              >Releases every pending {{ transaction.cryptocurrency }} transaction awaiting a rate</span
            >
            <app-button
              buttonVariant="primary"
              buttonType="button"
              [state]="exchangeRateButtonState"
              (buttonClick)="submitExchangeRate()"
              testId="submit-exchange-rate-button"
              ariaLabel="Submit exchange rate"
            >
              {{ isProcessing ? 'Processing...' : 'Submit rate' }}
            </app-button>
          </div>
        }
        @if (showRecordExchange) {
          <div *appHasPermission="{ resource: transactionResource, scope: Scopes.RecordExchange }">
            <app-button
              buttonVariant="primary"
              buttonType="button"
              [state]="processingButtonState"
              (buttonClick)="openRecordExchangeDialog()"
              testId="record-exchange-button"
              ariaLabel="Record Exchange"
            >
              Record Exchange
            </app-button>
          </div>
        }
        @if (isExchange) {
          <div *appHasPermission="{ resource: transactionResource, scope: Scopes.EditExchange }">
            <app-button
              buttonVariant="secondary"
              buttonType="button"
              [state]="processingButtonState"
              (buttonClick)="openEditExchangeDialog()"
              testId="edit-exchange-button"
              ariaLabel="Edit Exchange"
            >
              Edit Exchange
            </app-button>
          </div>
          <div *appHasPermission="{ resource: transactionResource, scope: Scopes.DeleteExchange }">
            <app-button
              buttonVariant="danger"
              buttonType="button"
              [state]="processingButtonState"
              (buttonClick)="openDeleteExchangeOtpDialog()"
              testId="delete-exchange-button"
              ariaLabel="Delete Exchange"
            >
              Delete Exchange
            </app-button>
          </div>
        }
      </div>
    }
  </div>
</div>
<ng-template #commentsBlock>
  <div class="comments-heading">Comments</div>
  @if (isMerchantApp && !showApproveReject && !canCancelPrepared) {
    <textarea
      class="comment-box"
      aria-label="Comments"
      placeholder="Enter your comment"
      [ngModel]="displayCommentText"
      [disabled]="true"
    ></textarea>
  } @else {
    <textarea
      class="comment-box"
      aria-label="Comments"
      placeholder="Enter your comment"
      [(ngModel)]="commentText"
      [disabled]="!canEditComments"
    ></textarea>
  }
</ng-template>
